import React from "react";
import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    Paging,
    Scrolling,
    Selection,
    Sorting,
    Toolbar,
    Item,
} from "devextreme-react/data-grid";

/**
 * One read-only grid shared by all four result tabs. They differ only in columns and, for Summary,
 * an extra right-aligned toolbar button, so four near-identical components would be duplication.
 *
 * These are stored-procedure aggregates, not entity rows, so there is deliberately no <Editing>,
 * no CustomStore and no concurrency store. There is also no Record # column (rule 10 does not
 * apply — no KEYSEQUENCE exists behind these rows) and no StateStoring, matching the sibling
 * Generate Storage Charges result grids.
 *
 * keyExpr is a synthetic index stamped by the page: the Summary set groups by five nullable
 * management units so a natural composite key can collide once nulls appear, and Detail has no
 * unique tuple at all. A duplicate key makes DevExtreme throw or drop rows.
 */
const DeferredRevenueResultGrid = ({ rows, columns, keyExpr, noDataText, toolbarAction }) => {
    const onExporting = (e) => {
        if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
        }
    };

    return (
        <DataGrid
            dataSource={rows || []}
            keyExpr={keyExpr}
            showBorders={true}
            rowAlternationEnabled={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnAutoWidth={true}
            hoverStateEnabled={true}
            noDataText={noDataText}
            className="search-page-grid"
            height="calc(100vh - 260px)"
            onExporting={onExporting}
        >
            <Selection mode="single" />
            <Sorting mode="multiple" />
            <FilterRow visible={true} />
            <Scrolling mode="virtual" rowRenderingMode="virtual" />
            <Paging enabled={true} pageSize={50} />
            <Export enabled={true} />
            <ColumnChooser enabled={true} />

            {columns.map((column) => (
                <Column key={column.dataField} {...column} />
            ))}

            <Toolbar>
                {/* Right-aligned; declared first so it sits left of the export/column-chooser icons. */}
                {toolbarAction && <Item location="after" render={toolbarAction} />}
                <Item name="exportButton" />
                <Item name="columnChooserButton" />
            </Toolbar>
        </DataGrid>
    );
};

export default DeferredRevenueResultGrid;
